import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData } from '../../../../helpers/ui/FileInput'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"
import Select from "react-select"

import { Link, useHistory, Redirect } from "react-router-dom"
import apiResponse from '../../../../services/apiResponse'
import CreateBloc from './Blocs/CreateBloc'
import { accessRole } from "../../../../helpers/access_role"
import CustomSelect from '../../../../helpers/ui/CustomSelect'


  const createYearOption = (startYear = 2021) => {
    var currentYear = new Date().getFullYear(), years = [];
      startYear = startYear || 1980;  
      while ( startYear <= currentYear ) {
          var newObj = {};
          var year = startYear++;
          newObj["label"] = year;
          newObj["value"] = year;
          years.push(newObj);
      }   
      return years;
  }

class IndexView extends Component {

    createBloc = new CreateBloc();

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {
                period_promotion_date: "",
                period_financial_revision_description: "",
            },
            employeeItems: [],
            employeeSelected: "",
            typeItems:[],
            typeSelected:"",
            yearOptions: createYearOption(2021),
            periodeOptions: [
                { label: "Januari", value: "01" },
                { label: "Februari", value: "02" },
                { label: "Maret", value: "03" },
                { label: "April", value: "04" },
                { label: "Mei", value: "05" },
                { label: "Juni", value: "06" },
                { label: "Juli", value: "07" },
                { label: "Agustus", value: "08" },
                { label: "September", value: "09" },
                { label: "Oktober", value: "10" },
                { label: "November", value: "11" },
                { label: "Desember", value: "12" }
            ],
            periode: "",
            periodeYear: ""
        }
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm) // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.createBloc.fetchCreate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values,
              period_financial_revision_date: `${this.state.periodeYear}-${this.state.periode}`
            },
            confirm: true
        })
    }


    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {

        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe();
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                           

                            <Card className="">
                                <CardBody>
                                    <CardTitle>Tambah Data Periode Revisi Keuangan</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Pilih Periode <span className="text-danger">*</span>
                                            </label>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="period_financial_revision_month"
                                                    onChange={(selected)=>{
                                                      this.setState({
                                                        periode : selected.value
                                                      })
                                                    }}
                                                    errorMessage="Pilih Bulan"
                                                    options={this.state.periodeOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Bulan"
                                                />
                                            </Col>
                                            <Col md="2">
                                                <CustomSelect 
                                                    name="period_financial_revision_year"
                                                    onChange={(selected)=>{
                                                      this.setState({
                                                        periodeYear : selected.value
                                                      })
                                                    }}
                                                    errorMessage="Pilih Tahun"
                                                    options={this.state.yearOptions} 
                                                    validate={{ required: { value: true } }}
                                                    placeholder="Pilih Tahun"
                                                    // defaultValue={new Date().getFullYear()}
                                                />
                                            </Col>
                                        </Row>

                                         <Row className="mb-3">
                                            <label
                                                htmlFor="no_sk"
                                                className="col-md-3 col-form-label"
                                            >
                                            Keterangan <span className="text-danger">*</span>
                                            </label>
                                            <Col md="9">
                                                    <AvField
                                                        name="period_financial_revision_description"
                                                        placeholder="Keterangan..."
                                                        type="textarea"
                                                        errorMessage="Masukkan Keterangan"
                                                        className="form-control"
                                                        rows="8"
                                                        id="period_financial_revision_description"
                                                    />
                                            </Col>
                                        </Row>

                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/revisi_keuangan.html">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/revisi_keuangan.html'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView